import React from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import { itemsSearch, animations } from "../../../services/app";
import ItemCharater from "../../../components/Item3d";
import { RowFilter } from "./RowFilter";
import Filter from "./filter/Filter";
import { ArrowDownIcon } from "../../../components/Icons/ArrowDownIcon";
import {
  CHARACTER_DEFAULT_PARAMS,
  ITEM_TYPES,
  ITEM_LIMIT,
} from "../../../constants";
import { useWindowSize } from "../../../hook/useWindowSize";
import FilterMobile from "./filter/FilterMobile";
import environment from "../../../environment";

export const TabCharacter = (props) => {
  const size = useWindowSize();
  const isMobile = size.width <= 1024 ? true : false;
  const { T, setLoading, language, user, convertToLocalCurrency,formatLocalCurrency,
    getCurrency } = useApp();
  const { gifttype, clearSearchParams } = props;
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [dataTab, setDataTab] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [categoryOptions, $categoryOptions] = useState([]);

  const [filterData, $filterData] = useState({
    ...CHARACTER_DEFAULT_PARAMS,
    size: ITEM_LIMIT,
    itemTypes: [ITEM_TYPES.ITEM_TYPE_AVATAR_3D, ITEM_TYPES.ITEM_TYPE_PET_3D],
    giftTypes: gifttype ? [gifttype] : undefined,
  });
  const [filterDataCache, $filterDataCache] = useState(filterData);

  const loadData = async () => {
    setLoading(true);
    const priceConvert = convertParams(filterData)
    const result = await itemsSearch({...filterData, ...priceConvert});
    setDataTab(result?.data?.data?.items?.rows || []);
    setTotal(result?.data?.data?.items?.count || 0);
    setLoading(false);
  };
  const loadMore = async () => {
    setLoading(true);
    const priceConvert = convertParams(filterData)
    const result = await itemsSearch({
      ...filterData,
      ...priceConvert,
      page: page + 1,
    });
    setDataTab((prev) => [...prev, ...result?.data?.data?.items?.rows] || []);
    setTotal(result?.data?.data?.items?.count || 0);
    setPage(page + 1);
    setLoading(false);
  };
  const handleShowFilter = () => {
    setShowFilter(!showFilter);
  };
  const handleFilterData = (val) => {
    $filterData({ ...filterData, ...val });
  };
  const convertParams = (filterData) => {
    const convertPrice = {
      priceFrom: undefined,
      priceTo: undefined,
      giftTypes: undefined,
    }
    if (filterData.giftTypes && filterData.giftTypes.length > 0) {
      if(filterData.giftTypes.includes("1")) {
        convertPrice.giftTypes = [1, 2]
      }else{
        convertPrice.giftTypes = [0]
      }
    }
    if(filterData.priceFrom && parseFloat(filterData.priceFrom) >= 0) {
      convertPrice.priceFrom = convertToLocalCurrency(filterData.priceFrom, getCurrency(), 'USD')
    }
    if(filterData.priceTo && parseFloat(filterData.priceTo) >= 0) {
      convertPrice.priceTo = convertToLocalCurrency(filterData.priceTo, getCurrency(), 'USD')
    }
    return convertPrice;
  }
  const handleCacheFilter = (val) => {
    $filterDataCache(val);
  };
  
  useEffect(() => {
    loadData();
    if (!filterData.giftTypes || !filterData.giftTypes.includes(gifttype)) {
      clearSearchParams('gifttype');
    }
  }, [filterData]);

  useEffect(() => {
    animations().then((res) => {
      const data = res?.data?.data?.data || [];
      $categoryOptions(data);
    });
  }, []);

  return (
    <div className="flex flex-col gap-[20px] lg:gap-[30px] mt-[10px]">
      <div className="search-input relative">
        <RowFilter
          handleShowFilter={handleShowFilter}
          showFilter={showFilter}
          filterData={filterData}
          type={"character"}
          setFilterData={handleFilterData}
        />
        {isMobile && (
          <FilterMobile
            setFilterData={(val) => handleFilterData(val)}
            setCacheFilter={(val) => handleCacheFilter(val)}
            filterData={filterData}
            categoryOptions={categoryOptions}
            showing={6}
            type={"character"}
          />
        )}
      </div>
      <div className="flex justify-between items-start gap-[40px]">
        {showFilter && !isMobile && (
          <div className="w-[270px] hidden lg:block">
            <Filter
              setFilterData={(val) => handleFilterData(val)}
              filterData={filterData}
              showing={6}
              categoryOptions={categoryOptions}
              type={"character"}
            />
          </div>
        )}
        <div className={`flex-1 ${!showFilter ? "w-full" : ""}`}>
          <div className="asset-block">
            <div className="mb-[15px] text-base text-black font-[700]">
              {T("Total item: {count}").replace("{count}", total)}
            </div>
            {dataTab?.length > 0 ? (
              <>
                <div
                  className={`grid gap-[15px] grid-cols-1 xs:grid-cols-2 xs:gap-[10px] ${
                    showFilter ? "lg:grid-cols-3" : "lg:grid-cols-4"
                  } lg:gap-[30px]`}
                >
                  {dataTab.map((item, index) => (
                    <ItemCharater key={index} itemData={item} />
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="text-[#818181] text-sm flex-wrap lg:text-base flex justify-center items-center">
                  <div className="w-full flex items-center lg:mt-[80px] mb-[16px] justify-center">
                    <img
                      className="w-[100px] lg:w-[160px]"
                      src={"/assets/images/empty-table.png"}
                      alt=""
                    />
                  </div>
                  <div className="w-full flex justify-center mb-[15px]">
                    {T("You haven't got anything yet.")}
                  </div>
                </div>
              </>
            )}
          </div>
          {total > page * filterData.size && (
            <>
              <div
                className="flex justify-center items-center mt-[40px] gap-[10px]"
                onClick={() => loadMore()}
              >
                {T("Load more")} <ArrowDownIcon />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
